define('services/analytics/agentAnalyticsService',[
    'lib/bluebird',
    'lib/knockout',
    'services/analyticsService',
    'services/apiCore',
    'services/authService'
], function (
    Promise,
    ko,
    analyticsService,
    apiCore,
    authService
) {
    'use strict';

    var USER_DIMENSION_NAME = "userId";
    var USER_CONVERSATIONS_METRICS = "conversations/aggregates/query";
    var USER_CONVERSATIONS_DETAILS = "conversations/details/query";
    var USER_PRESENCE = "users/aggregates/query";

    var agentAnalytics = {

        /**
         * Queries the Analytics Service with one filter for an agent.
         * @param  {String} agentId - ID of agent
         * @param  {String} interval - ISO8601 specified time interval, indicating the time range for the data requested
         * @param  {Object} options
         * @return {promise} promise that resolves with the response from the server
         */
        loadAgentData: function (agentId, interval, options) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:conversationAggregate:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:conversationAggregate:view needed"));
            }

            var id = ko.unwrap(agentId);
            var intervalArg = ko.unwrap(interval);

            return analyticsService.execAggregateQuery(
                id,
                USER_CONVERSATIONS_METRICS,
                [USER_DIMENSION_NAME],
                intervalArg,
                options
            );
        },

        loadAgentInteractions: function (payload) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:conversationDetail:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:conversationDetail:view needed"));
            }

            return apiCore.v2.post('/analytics/' + USER_CONVERSATIONS_DETAILS, payload);
        },

        /**
         * Queries the Analytics Service with multiple filters (disjunction query)
         * @param  {String} agentId - ID of agent
         * @param  {String} interval - ISO8601 specified time interval, indicating the time range for the data requested
         * @param  {Object} options
         * @return {promise} promise that resolves with the response from the server
         */
        loadAgentsData: function (agentIds, interval, options) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:conversationAggregate:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:conversationAggregate:view needed"));
            }

            var idArr = ko.unwrap(agentIds);
            var intervalArg = ko.unwrap(interval);

            var agentsData = analyticsService.execDisjunctionAggregateQuery(
                idArr,
                USER_CONVERSATIONS_METRICS,
                [USER_DIMENSION_NAME],
                intervalArg,
                options
            );
            return agentsData;
        },

        loadAgentPresenceData: function (agentId, interval, options) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:userAggregate:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:userAggregate:view needed"));
            }

            var id = ko.unwrap(agentId);
            var intervalArg = ko.unwrap(interval);

            return analyticsService.execAggregateQuery(
                id,
                USER_PRESENCE,
                [USER_DIMENSION_NAME],
                intervalArg,
                options
            );
        }

    };

    return agentAnalytics;

});

